import { gql } from 'graphql-request';

import {
  MaterialSetDownloadUrlsClassName,
  MaterialSetDownloadUrlsID,
  MaterialSetDownloadUrlsType,
  MaterialSetDownloadUrlsUrl,
  MaterialSetDownloadUrlsUUID,
  MaterialsSetID,
  MaterialsSetUUID
} from '../materialsSetsTypes';

export interface FetchMaterialsSetDownloadUrlsQueryResponse {
  id: MaterialsSetID;
  uuid: MaterialsSetUUID;
  downloadUrls: {
    url: MaterialSetDownloadUrlsUrl;
    id: MaterialSetDownloadUrlsID;
    uuid: MaterialSetDownloadUrlsUUID;
    type: MaterialSetDownloadUrlsType;
    className: MaterialSetDownloadUrlsClassName;
  }[];
}

export const FETCH_MATERIALS_SET_DOWNLOAD_URLS_QUERY = gql`
  query MaterialsSetDownloadUrls($uuid: ID!) {
    materialsSet(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
